module.exports = __webpack_public_path__ + "img/facebook.c509a4c4.svg";